// ===== GLOBAL HELPERS
// ==========================================

var global_helpers = {

    settings: {
        data_anchor_links: $('[data-anchor-link]'),
        body: $('body'),
        header: $('header'),
    },

    init: function () {
        // Data Anchor Links
        if (this.settings.data_anchor_links.length) {
            this.dataAnchorLinks();
        }
    },

    // Allow smooth scrolling to an ID with data-anchor-link
    dataAnchorLinks: function () {

        global_helpers.settings.data_anchor_links.each(function () {

            if ($(this).attr('data-anchor-link').length) {
                // Get the link
                var link = $(this);
                // Get the target
                var target = $('#' + link.attr('data-anchor-link'));

                if (link.length) {
                    // Bind the event
                    link.on('click', function () {

                        var header = $('header').outerHeight();
                        var offset = target.offset().top - header - 50;

                        $('html, body').animate({
                            scrollTop: offset
                        }, 1000);

                    });
                }
            }

        });

    },

    // Returns a function that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If 'immediate' is passed, trigger the function on the
    // leading edge, instead of the trailing.
    //
    // Use:  $(window).resize(global_helpers.debounce(function() { ...[your code here]... }, 500));
    // Source:  http://davidwalsh.name/javascript-debounce-function
    debounce: function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args); }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) { func.apply(context, args); }
        };
    },

}
global_helpers.init();
